import styled from '@emotion/styled'
import { BookablePersonType } from '@sales-app/types/BookablePersonType'
import { CommunicationLogs } from '@sales-app/views/Workspace/PersonSummary/CommunicationLogs/CommunicationLogs'
import React, { FC } from 'react'

import { Tab, Tabs } from '@/components'
import { TicketDetail } from '@/types/Ticket'
import { SectionContainer } from '@/views/Ticket/Ticket/SectionContainer'

import { CommunicationSection } from './CommunicationSection/CommunicationSection'
import { MediaSection } from './MediaSection/MediaSection'
import { TicketDetailTab } from './TicketDetailTabs'

interface UpdatesSectionProps {
  selectedTab: TicketDetailTab
  ticketData: TicketDetail
}

export const UpdatesSection: FC<UpdatesSectionProps> = ({ ticketData }) => {
  const bookablePerson =
    ticketData.contact && ticketData.contact.id
      ? {
          bookablePersonId: ticketData.contact.id,
          bookablePersonType: BookablePersonType.MEMBER,
        }
      : null

  return (
    <SectionContainer className="w-full flex-1">
      <p className="mb-6 hidden text-header-md md:block">Activity</p>
      <StyledTabs>
        <Tabs>
          <Tab key="feed" title="Feed">
            <CommunicationSection ticketData={ticketData} />
          </Tab>
          <Tab key="media" title="Media">
            <MediaSection ticketData={ticketData} />
          </Tab>
          <Tab key="communications" title="Communications">
            <>{bookablePerson && <CommunicationLogs bookablePerson={bookablePerson} />}</>
          </Tab>
        </Tabs>
      </StyledTabs>
    </SectionContainer>
  )
}

const StyledTabs = styled.div`
  .title-container {
    border-color: #e7e6e4;
    border-width: 1px;
    border-radius: 0.5rem;
    overflow: hidden;
    position: relative;
    margin-bottom: 0.5rem;
  }

  .tab-title {
    position: relative;
    flex: 1;
    margin-right: 0;

    button {
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
      padding-left: 0.25rem;
      padding-right: 0.25rem;
      font-size: var(--text-p-sm);
      text-align: center;
      width: 100%;
      white-space: nowrap;
      font-weight: 500;
      line-height: 1.4;
      background-color: transparent;
      text-transform: capitalize;

      @media (min-width: 768px) {
        font-size: 1rem;
      }

      cursor: pointer;
    }

    &.active {
      button {
        color: white;
        font-weight: 700;
        background-color: black;
      }
    }
  }
`
